import React, { FC, useState } from "react";
import { Button } from "primereact/button";
import { NO_IMAGE } from "../../../../assets";
import { ProviderAboutSection } from "../../../../models/manageWebSite";
import EditModal from "./EditModal";

interface Props {
  data: ProviderAboutSection | null;
  flag: boolean;
  setFlag: (flag: boolean) => void;
  homeId: string | null;
}

const Section11: FC<Props> = ({ data, flag, setFlag, homeId }) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div style={{ width: "100%", background: "linear-gradient(180deg, #fff5fb 0%, #f8fafc 100%)", padding: "3rem 1.25rem" }}>
      <div style={{ maxWidth: "1180px", margin: "0 auto" }}>
        <div className="flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
          <div>
            <div style={{ color: "#be185d", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", fontSize: "0.8rem" }}>Optional Page</div>
            <div style={{ color: "#0f172a", fontSize: "2rem", fontWeight: 800, marginTop: "0.65rem" }}>About</div>
            <div style={{ color: "#64748b", marginTop: "0.65rem", lineHeight: 1.7, maxWidth: "760px" }}>
              Add a provider story page with your background, care philosophy, reasons families choose the home, and testimonials.
            </div>
          </div>
          <Button label="Edit About Page" severity="warning" className="website-section-action-button" onClick={() => setOpenModal(true)} />
        </div>
        <div className="grid">
          <div className="col-12 lg:col-6">
            <div style={{ background: "#ffffff", border: "1px solid #f3d5e6", borderRadius: "24px", padding: "1.2rem", height: "100%", boxShadow: "0 16px 32px rgba(190,24,93,0.06)" }}>
              <div style={{ display: "flex", justifyContent: "center", marginBottom: "1rem" }}>
                <img
                  src={data?.providerSignedImg || NO_IMAGE}
                  alt="Provider"
                  style={{ width: "100%", maxWidth: "240px", aspectRatio: "1 / 1", objectFit: "cover", borderRadius: "24px", border: "1px solid #f3d5e6" }}
                />
              </div>
              <div style={{ color: "#be185d", fontWeight: 800, textTransform: "uppercase", fontSize: "0.8rem", letterSpacing: "0.1em" }}>Meet the provider</div>
              <div style={{ color: "#475569", lineHeight: 1.85, marginTop: "0.9rem", whiteSpace: "pre-line" }}>{data?.meetTheProvider}</div>
              <div style={{ color: "#be185d", fontWeight: 800, textTransform: "uppercase", fontSize: "0.8rem", letterSpacing: "0.1em", marginTop: "1.2rem" }}>Care philosophy</div>
              <div style={{ color: "#475569", lineHeight: 1.85, marginTop: "0.9rem", whiteSpace: "pre-line" }}>{data?.carePhilosophy}</div>
            </div>
          </div>
          <div className="col-12 lg:col-6">
            <div style={{ background: "#ffffff", border: "1px solid #f3d5e6", borderRadius: "24px", padding: "1.2rem", height: "100%", boxShadow: "0 16px 32px rgba(190,24,93,0.06)" }}>
              <div style={{ color: "#be185d", fontWeight: 800, textTransform: "uppercase", fontSize: "0.8rem", letterSpacing: "0.1em" }}>Why families choose us</div>
              <ul style={{ paddingLeft: "1rem", margin: "0.9rem 0 0", lineHeight: 1.85, color: "#475569" }}>
                {(data?.whyFamiliesChooseUs || []).map((item, index) => <li key={`${item}-${index}`}>{item}</li>)}
              </ul>
              <div style={{ color: "#be185d", fontWeight: 800, textTransform: "uppercase", fontSize: "0.8rem", letterSpacing: "0.1em", marginTop: "1.2rem" }}>Testimonials</div>
              <ul style={{ paddingLeft: "1rem", margin: "0.9rem 0 0", lineHeight: 1.85, color: "#475569" }}>
                {(data?.testimonials || []).map((item, index) => <li key={`${item}-${index}`}>{item}</li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <EditModal isOpen={openModal} toggleModal={setOpenModal} flag={flag} setFlag={setFlag} data={data} homeId={homeId} />
    </div>
  );
};

export default Section11;
